import { render, staticRenderFns } from "./Strophoid.vue?vue&type=template&id=0142165d&scoped=true&"
import script from "./Strophoid.vue?vue&type=script&lang=js&"
export * from "./Strophoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142165d",
  null
  
)

export default component.exports